import AsyncStorage from "./AsyncStorage";
export { useAsyncStorage } from "./hooks";
export default AsyncStorage;
//# sourceMappingURL=index.js.map